export default "__VITE_ASSET__421a468b__"